angular.module('gym.pos').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.pos.sales', {
    abstract: true,
    template: '<ui-view>'
  }).state('gym.pos.sales.new', {
    url: '/sales/new?saleId&contactId',
    template: require('templates/gyms/pos/sales/new.html.slim'),
    reloadOnSearch: false
  }).state('gym.pos.sales.edit', {
    url: '/sales/:saleId',
    template: require('templates/gyms/pos/sales/new.html.slim')
  }).state('gym.pos.sales.list', {
    url: '/sales',
    template: require('templates/gyms/pos/sales/index.html.slim')
  }).state('gym.pos.sales.contactDetails', {
    url: '/sales/contact_details',
    controller: 'PosSaleContactDetailsCtrl',
    template: require('templates/gyms/pos/sales/contact_details.html.slim')
  });
}]);
